import { useContext } from 'react';
import { Blocker } from 'react-router';
import { NavigationBlockerContext } from '../contexts/navigationBlockerContext';

export const usePreventNavigation = (): { blocker: Blocker; setShouldBlockNavigation: (shouldPreventNavigation: boolean) => void } => {
    const context = useContext(NavigationBlockerContext);
    if (!context) {
        throw new Error('usePreventNavigation must be used within NavigationBlockerProvider');
    }
    const { blocker, setShouldBlockNavigation } = context;

    return { blocker, setShouldBlockNavigation };
};
